import { FC, useEffect } from "react";
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CreateLink,
  DiffSourceToggleWrapper,
  ListsToggle,
  MDXEditor,
  Separator,
  diffSourcePlugin,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  toolbarPlugin
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";

type Props = {
  original: string;
  value: string;
  onChange: (value: string) => void;
  readOnly: boolean;
};

export const MDXEditorView: FC<Props> = ({
  value,
  onChange,
  original,
  readOnly
}) => {
  useEffect(() => {
    // That's a hack to remove the underline button from the toolbar
    // because it's not supported by the markdown format
    // There is no official way to remove a button from the toolbar
    // via conventional Props API
    document.querySelector('button[title="Underline"]')?.remove();
  }, []);

  return (
    <div className="markdown-prose hide-scroll min-h-[650px] w-full max-w-none bg-background-1000 overflow-y-scroll rounded-md border border-alpha-100 text-content-1000 focus:border-primary-500 focus:outline-0 focus:ring-0">
      <MDXEditor
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        markdown={value ?? ""}
        readOnly={readOnly}
        plugins={
          readOnly
            ? [
                linkPlugin(),
                listsPlugin(),
                linkDialogPlugin(),
                headingsPlugin()
              ]
            : [
                linkPlugin(),
                listsPlugin(),
                linkDialogPlugin(),
                headingsPlugin(),
                diffSourcePlugin({
                  viewMode: "rich-text",
                  diffMarkdown: original,
                  readOnlyDiff: true
                }),
                toolbarPlugin({
                  toolbarContents: () => (
                    <>
                      <BoldItalicUnderlineToggles />
                      <Separator />
                      <CreateLink />
                      <ListsToggle />
                      <BlockTypeSelect />
                      <DiffSourceToggleWrapper>
                        <div className="sr-only" />
                      </DiffSourceToggleWrapper>
                    </>
                  )
                })
              ]
        }
        onChange={(e) => {
          if (!readOnly) onChange(e);
        }}
      />
    </div>
  );
};
